import moment from "moment";
import React from "react";
import Loading from "../../../common/components/Loading";
import Pagination from "../../../common/components/Pagination";
import Thumbnail from "../../../common/components/Thumbnail";
import {
  Flex,
  Table,
  TableCell,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  TextButton,
} from "../../../common/styles/commonStyles";
import useExhibitionListTable from "./ExhibitionListTable.hook";

function ExhibitionListTable({ onSelectExhibition }) {
  const { models, operations } = useExhibitionListTable();

  const { data, loading, offset, totalPageCount } = models;

  const { onPageChange, onDeleteClick } = operations;

  return (
    <Flex
      flex={9}
      overflowY="auto"
      flexDirection="column"
      width="100%"
      justifyContent="flex-start"
      alignItems="flex-start"
      padding={12}
    >
      <Table>
        <TableHead>
          <TableHeadRow>
            <TableHeadCell width="8%">ID</TableHeadCell>
            <TableHeadCell width="8%">대표 이미지</TableHeadCell>
            <TableHeadCell width="8%">배경 이미지</TableHeadCell>
            <TableHeadCell width="8%">타이틀</TableHeadCell>
            <TableHeadCell width="15%">소개</TableHeadCell>
            <TableHeadCell width="5%">기획</TableHeadCell>
            <TableHeadCell width="5%">주최</TableHeadCell>
            <TableHeadCell width="5%">후원</TableHeadCell>
            <TableHeadCell width="10%">전시 기간</TableHeadCell>
            <TableHeadCell width="8%">등록일</TableHeadCell>
            <TableHeadCell width="5%">박수</TableHeadCell>
            <TableHeadCell width="5%">조회수</TableHeadCell>
            <TableHeadCell width="5%">수정</TableHeadCell>
            <TableHeadCell width="5%">삭제</TableHeadCell>
          </TableHeadRow>
        </TableHead>
        {loading ? (
          <tbody>
            <tr>
              <td colSpan="100%">
                <Loading />
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {data?.map((exhibition) => {
              const {
                id,
                primaryMedia,
                backgroundMedia,
                title,
                introduction,
                director,
                sponsor,
                host,
                from,
                to,
                createdAt,
                claps,
                viewCount,
              } = exhibition;

              return (
                <TableRow key={id}>
                  <TableCell>{id}</TableCell>
                  <TableCell>
                    <Thumbnail width={100} height={100} media={primaryMedia} />
                  </TableCell>
                  <TableCell>
                    {backgroundMedia ? (
                      <Thumbnail
                        width={100}
                        height={100}
                        media={backgroundMedia}
                      />
                    ) : (
                      "이미지 없음"
                    )}
                  </TableCell>
                  <TableCell>{title}</TableCell>
                  <TableCell>{introduction}</TableCell>
                  <TableCell>{director}</TableCell>
                  <TableCell>{host || ""}</TableCell>
                  <TableCell>{sponsor || ""}</TableCell>
                  <TableCell>
                    {moment(from).format("YYYY-MM-DD")} <br />~
                    {moment(to).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>
                    {moment(createdAt).format("YYYY-MM-DD")}
                  </TableCell>
                  <TableCell>{claps}</TableCell>
                  <TableCell>{viewCount}</TableCell>
                  <TableCell>
                    <TextButton
                      padding={4}
                      onClick={() => onSelectExhibition(id)}
                    >
                      수정
                    </TextButton>
                  </TableCell>
                  <TableCell>
                    <TextButton
                      padding={4}
                      backgroundColor="red"
                      onClick={async () => await onDeleteClick(id)}
                    >
                      삭제
                    </TextButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </tbody>
        )}
      </Table>
      <Pagination
        forcePage={offset}
        pageCount={totalPageCount}
        pageRangeDisplayed={5}
        previousLabel="Prev"
        nextLabel="Next"
        onPageChange={onPageChange}
      />
    </Flex>
  );
}

export default ExhibitionListTable;
